import React from "react";
import { Navigate, Views } from "react-big-calendar";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { DatePicker } from "antd";
import { Segmented } from "antd/lib";
import dayjs, { Dayjs } from 'dayjs';
import events from "../../../../../resources/event";


const Toolbar = ({onNavigate, onView, activeRange, updateView, view}: any) => {

    const resource = events.toolbar;
    const dateFormat = "MMMM YYYY"

    const options = [
        {
            label: resource.gotoMonthButtonText,
            value: 'month'
        },
        {
            label: resource.gotoWeekButtonText,
            value: 'week'
        },
        {
            label: resource.gotoDaysButtonText,
            value: 'day'
        }
    ];

    const handleView = (val: string) => {

        switch (val) {
            case 'month':
                updateView('month');
                onView(Views.MONTH);
                break;
            case 'week':
                updateView('week');
                onView(Views.WEEK);
                break;
            case 'day':
                updateView('day');
                onView(Views.DAY);
                break;
            default:
                return;

        }
    };

    const handleMonthYearChange = (value: Dayjs | null) => {
        if (!value) return;

        const selectedMonth = value.startOf('month');

        updateView('month');
        onView(Views.MONTH);
        onNavigate(Navigate.DATE, selectedMonth.toDate());
    };

    function handlePrevious() {
        onNavigate(Navigate.PREVIOUS);
    }

    function handleNext() {
        onNavigate(Navigate.NEXT)
    }

    const eventInfo = [
        {
            label: 'Work Anniversary',
            key: 'workAnniversary'
        },
        {
            label: 'Birthday',
            key: 'birthday'
        },
        {
            label: 'Custom Event',
            key: 'event'
        },
        {
            label: 'Training',
            key: 'training'

        }
    ];

    return (
        <div className="hrms-events__toolbar">

            <div className="hrms-events__legend">
                <h6 className="hrms-events__legend-title">Event Type</h6>
                <div className="hrms-events__legend-list">
                    {eventInfo.map((item) => (
                        <div
                            key={item.key}
                            className={`hrms-events__legend-item hrms-events__legend-item--${item.key}`}
                        >
                            <span className="hrms-events__legend-color"/>
                            <span className="hrms-events__legend-label">
                             {item.label}
                             </span>
                        </div>
                    ))}
                </div>
            </div>

            <div className={'hrms-events__action-bar'}>
                <button
                    className="hrms-events__calendar-today-btn"
                    onClick={() => onNavigate(Navigate.TODAY)}
                >
                    {resource.todayButtonText}
                </button>

                <DatePicker
                    picker="month"
                    value={dayjs(activeRange.start)}
                    format={dateFormat}
                    onChange={handleMonthYearChange}
                    className="hrms-events__calendar-picker"
                />

                <Segmented
                    options={options}
                    value={view}
                    onChange={(value) => handleView(value)}
                    className="hrms-events__toggle-group calendar-view-toggle"
                />

                <div className="hrms-events__calendar-navigation">
                    <span
                        className="nav-icon"
                        onClick={handlePrevious}
                    ><LeftOutlined/>
                    </span>

                    <span
                        className="nav-icon"
                        onClick={handleNext}
                    >
                    <RightOutlined/>
                    </span>
                </div>
            </div>
        </div>

    );
};

export default Toolbar;
